var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConsulting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consulting_svg__clip0)",
    fill: "#F2F2F2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.006 31.937l-6.773-16.086h3.37V14.09H34.612c-.413-2.23-2.326-3.787-4.582-3.787-.692 0-1.263.124-1.967.397V1.76h3.875v7.515h1.76V0h-7.396v12.094h.077a4.32 4.32 0 00-.873 1.996H7.515v1.761h3.37L4.112 31.937H1.88v.822c0 5.665 4.609 10.274 10.274 10.274 5.665 0 10.274-4.609 10.274-10.274v-.822H20.31l-6.773-16.086h11.968c.139.705.444 1.32.873 1.879h-.077v29.12h1.76V19.123c.705.273 1.247.426 1.938.426a4.6 4.6 0 001.938-.426v29.721h-9.394v3.758h-3.757V60h22.427v-7.397h-3.758v-3.758H33.7V17.73h.04c.43-.56.734-1.174.873-1.879H46.58l-6.773 16.086h-2.233v.822c0 5.665 4.608 10.274 10.274 10.274 5.665 0 10.274-4.609 10.274-10.274v-.822h-2.116zM20.679 33.7c-.442 4.227-4.07 7.632-8.467 7.632s-8.026-3.405-8.468-7.632H20.68zm-2.28-1.762H6.024l6.189-14.697L18.4 31.937zM30.06 17.79a2.88 2.88 0 01-2.877-2.877 2.88 2.88 0 012.877-2.877 2.88 2.88 0 012.877 2.877 2.88 2.88 0 01-2.877 2.877zm7.456 36.575h1.937v3.875H20.548v-3.875H37.515zm-1.82-3.757v1.996h-11.39v-1.996h11.39zM47.906 17.24l6.189 14.697H41.718l6.188-14.697zm0 24.09c-4.396 0-8.025-3.404-8.467-7.631h16.935c-.442 4.227-4.071 7.632-8.468 7.632z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 14.09H29.12v1.761H31V14.09z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "consulting_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
}

export default SvgConsulting;